<template>
	<van-popup class="advertisement_-conter" v-model="$store.state.isRechargeGift" z-index="2300">
		<div class="advertisement_list _border">
				<div class="ZAJ3tO484KoZnr7Y6n_l">{{$t('components._Bnusdeprimeirodepsito')}}</div>
				<div class="xmHlf3AdKNfopQZxGTk7">
						<div class="wPL4o40ajO3bGEmyjpNf">
								<div class="listTitle-UKWM2" style="background: var(--cms-background-color-secondary);">
									<h2 title="intl_activity_rule_title_5_targetValue_v2" :style="{color:config.ui_version=='3.7'?'var(--skin__primary)':''}">{{$t('promote._Primeirodepsito')}}</h2>
									<h2 title="intl_activity_rule_title_presenterValue_v2" :style="{color:config.ui_version=='3.7'?'var(--skin__primary)':''}">{{$t('promote._Recompensa')}}</h2>
								</div>
								<div class="listItem-WUKaB" v-for="(item,index) in first_recharge.config"
									style="background: var(--cms-background-color-primary);">
									<div :style="{color:config.ui_version=='3.7'?'var(--skin__primary)':''}">≥ {{item[0]}}</div>
									<div :style="{color:config.ui_version=='3.7'?'#feb705':''}">{{item[1]}}</div>
								</div>
						</div>
				</div>
				<div class="login-register-from-space ">
					<div>
						
						<van-checkbox v-model="todayChecked" style="padding-bottom:.12rem" shape="square" checked-color="var(--theme-secondary-color-success)"
							icon-size=".32rem">
							<span class="chen_texbt">{{$t('components._hojeNovamente')}}</span>
						</van-checkbox>
						<van-checkbox v-model="permanentChecked" style="padding-bottom:.12rem"  shape="square" checked-color="var(--theme-secondary-color-success)"
							icon-size=".32rem">
							<span class="chen_texbt">{{$t('components._Ocultarpermanenfemente')}}</span>
						</van-checkbox>
					</div>
					<div class="smallBtn-VvG4v" @click="openUelConems(first_recharge.jump)">
						{{$t('components._Prosseguir')}}
					</div>
				</div>
		</div>
		
		
		<div class="" style="display: flex;align-items: center;justify-content: center;margin-top: .4rem;">
			<img style="width: 0.5984rem;height: 0.5984rem;cursor: pointer;" @click="cunSltenmefals"
				src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAABYCAMAAABGS8AGAAAAilBMVEUAAAD////e5Orv8vXe5Or////e5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Or////////h5+z8/f7z9ffm6/Dp7fHt8PT5+vv2+PrCEzcDAAAAJXRSTlMAYJYggoAJR6DVzbyRfHYuimpXKBlePTURrlDbxOm27OJwZaif1OMsUAAABGNJREFUWMPdmdtiojAQhlNAOSOoeK6tugRy4P1fb0lCO26DDRiv9r8Twsfkz0wSA/ovtVh6tzj8fP/4eP+M4iBdrpC93GtwJJQ1La+leNswisOgXNtQd9czpg2vNPGG4v1y/iR2lWDaVo9Ud2xv/YyxDmnqnsG77hOCOxFhC/+6znDuTsSuHdx89ZrgU5CW/nbluqutX6ZBJP1RYeN8kiEZZv2DJMr9nfbaZRL2/alZdJ3ignyIU5xvHzXaOJipVsQZaXWBG4UNi99zJuvR7LQcw00Il63xxdw2VTG02DO3dahqmuxG1Y8jw6iJY2g4V1wWH9BIFZEMmjoGLlPv302oI4eayYqLczRJKomoY/CX4wxNVI4F+bHPDpHcAk2Wp8gPcuOChQ/AnURWzx4GByEUiYNT9JQS0ds2HjSiEb1JnoDC+LABmzMCN55SIALDpVb4wn4eWSw4G0k4aR4x8b4rslAq+ky9HyOHlRFWujUiM34ELK9JI2zM0EJewyUbJVrIHuuufNpvQsT40QKB5IVsoOVsNnMRGnEDQuYh/F5S0QV9uX2rhN7QmBuQAwTWyX33osbRw6qU3nSukh5z3Hak/J/iIBut1awC8hC3mmmPlLQfLHDiiAbBQNa51R99CcL1nReOcCIZBgNZ50LEoHPHYl9pIOZLekCDHgNZ54LHoIx1QZ7758VQalUHECBrl3RtCSTYgYh5DSET2cgFkxcQfYDMZANX6dR2vi6/x455aAR5BBcFMHpiIGmJRpDNXDXt9MUW8c4VHxnII7mooN9pEXJZdwaymQvV1qoF6hPG0UQ2c5EPOfbRgfEKmcnANYHDEWAgA9cMBivswboVRzF4W3srYPD4SUs3+8G7iqw4qwJpoUDs0y2VEwQUYfqSAgEavONVJR3L/oPd0asmIVib5Jpd491rps3F3USPjjWkhe1EX1C5sQe/m/w1S9PtfnIvhcmh9WIKFm9grwnzm93yf5AWaxsj6w0LbNagDOt3yy0W9H3z75pNC+tNob7PduS+1mYbCwGy7D6tZRcuA/vrP7C/Nt/IGVTHXfrxI7LTSgacD/zhSezADvz1+nnRt+EWIjj2M7iF6EZztuC6IRd2zjXjqTx+sTCCQQJoRVOR9GkuqWTR6fJxLWwun+OmwmAeDuamR8S96PDUwMlDIVz8ckjSxk+Qr5hrxzOa/+1pshsXzH8feddpBBlfph67cdNpx0KSOZ5SgnOH1JI7R0ZyTZ3FWK6/Z5Xk7kzntrJdg7OxNvSHsfORPavpmOwoI1rD8bFJHm7l2TTZG+akZUz4pO4dYlbLB0hUrB96loVEBlDTYDN6oBPlXMUp3hergTG+xJjxSoXrTTrpupH2+8tPeEuXW3c37964c7eltz8SJu7KTpnzRzewqZTkFyHcS34TqnqsNgwjM5So7irVUvCbMwzmTtTCw6LTuuqWkShzkYV874T774TwpZDgON0ia7mHNDgdu++anT7ej3GQ+Wv0H+ov9UMLyPmx8boAAAAASUVORK5CYII=">
		</div>
	</van-popup>
</template>

<script>
	import {
		dailySignIn,
		firstRecharge
	} from "@/apis/modules/detail.js"
	import {
		mapState
	} from 'vuex';
	import {
		Toast
	} from 'vant';
	export default {
		// isRechargeGift
		props: {
			isShow: {
				type: Boolean,
				required: true,
			},
			model: {
				type: [Object, Array],
				required: {},
			}
		},
		computed: {
			...mapState(['first_recharge','config'])
		},
		data() {
			
			return {
				codeValue: '',
				checked:false,
				todayChecked:false,
				permanentChecked:false,
				CancelDisplay: false,
				mesnComenste: false,
				inputFocus: false,
				formDate: {}
			};
		},
		created() {
		},
		methods: {
			getNotification() {
				firstRecharge({}).then(({
					code,
					data,
					msg
				}) => { //404
					this.formDate = data;
					// 
				})
			},
			cunSltenmefals() {
				this.$store.commit('publicFun',['isRechargeGift',false])
				// todayChecked:false,
				// permanentChecked:false,
				if(this.permanentChecked){
					window.localStorage.setItem('isRechargeGift',false)
				}else if(this.todayChecked){
					window.localStorage.setItem('isRechargeGiftTime',(new Date()).getTime()+24*60*60*1000)
				}
			},
			openUelConems(jump){
				if(jump != 'firstRecharge')return;
				this.$store.commit('publicFun',['isRechargeGift',false])
				this.openUrl('firstRecharge')
			}
		},
	}
</script>
<style>
	.login-body {
		font-weight: 400;
	}

	.van-popup.advertisement_-conter {
		background-color: transparent;
	}

	.ZaAWGnvFuhPwlBk40od_.svg-icon {
		width: .24rem !important;
		height: .24rem !important;
		color: var(--theme-label-secondary-color-finance);
		margin-left: .15rem;
	}
</style>
<style scoped>
	
	.smallBtn-VvG4v {
	    padding: 0 .2rem;
	    height: .5rem;
	    font-size: .2rem;
	    border-radius: .14rem;
	    border: 0;
		text-align: center;
		line-height: .5rem;
		color: var(--theme-primary-font-color);
		background-color: var(--theme-primary-color);
		border-color: var(--theme-primary-color);
	    box-sizing: border-box;
	    border: none;
	    outline: none;
		cursor: pointer;
	}
	.login-register-from-space{
		padding: 0 .2rem;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.login-register-from-space .chen_texbt{
		font-size: .2rem;
		color: var(--theme-text-color-darken);
	}
	.listTitle-UKWM2 {
	    display: flex;
	    border: .02rem solid var(--theme-color-line);
	    height: .8rem;
	    align-items: center;
	    border-radius: .1rem;
	    background: var(--theme-main-bg-color) !important;
	    color: var(--theme-text-color-process-text);
	    top: .2rem
	}
	.listTitle-UKWM2>h2 {
	    font-size: .24rem;
	    line-height: 1;
	    flex: 1;
	    text-align: center;
	    font-weight: 0;
	    color: var(--theme-text-color-process-text);
	    word-break: break-word;
	    padding: 0 .1rem;
	    line-height: .3rem;
	    display: -webkit-box;
	    overflow: hidden;
	    text-overflow: ellipsis;
	    vertical-align: middle;
	    -webkit-line-clamp: 3;
	    -webkit-box-orient: vertical
	}
	.listItem-WUKaB {
	    display: flex;
	    min-height: .7rem;
	    align-items: center;
	    padding: .1rem 0;
		background-color: var(--theme-main-bg-color) !important;
	    box-sizing: border-box;
		border-radius: .14rem;
	}
	.listItem-WUKaB>div:last-child {
	    color: var(--theme-primary-color);
	}
	.listItem-WUKaB>div {
	    flex: 1;
	    text-align: center;
	    font-size: .2rem;
	    color: var(--cms-text-color-secondary);
	}
	.listItem-WUKaB:nth-child(2n){
		background-color: var(--theme-bg-color) !important;
	}
	
	.wPL4o40ajO3bGEmyjpNf {
		background-color: var(--theme-bg-color);
		/* border: 0.01rem solid var(--theme-primary-color); */
		border-radius: .1rem;
		box-shadow: 0 .03rem .09rem 0 rgba(0, 0, 0, .06);
		padding: .25rem .2rem;
	}

	.van-button--primaryui-button--success {
		background-color: var(--theme-disabled-bg-color);
		border-color: var(--theme-disabled-bg-color);
		color: var(--theme-disabled-font-color);
	}

	._sign-item0_zocom_39 ._reward-pattern_zocom_54 {
		margin-top: 0
	}

	._sign-item0_zocom_39 ._caption_zocom_135 {
		height: .55rem !important;
	}

	._sign-item0_zocom_39 .sign-badge,
	._sign-item6_zocom_158 .sign-badge {
		left: auto;
		right: -.15rem
	}



	._item_zocom_17._sign-item0_zocom_39:nth-child(3n) {
		margin-right: 0
	}

	._item_zocom_17 .sign-badge {
		position: absolute;
		top: 0;
		left: 50%;
		transform: none;
		right: auto;
		max-width: inherit !important;
		color: #ff0
	}

	._item_zocom_17 ._reward-pattern_zocom_54 {
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 1.24rem;
		height: 1.24rem;
		margin: .2rem auto 0;
	}

	._item_zocom_17 ._reward-pattern_zocom_54 .received-box {
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 100%
	}

	._item_zocom_17 ._reward-pattern_zocom_54 .received-box .bg-receive {
		position: absolute;
		top: 50%;
		left: 50%;
		font-size: 1.24rem;
		transform: translate(-50%, -50%)
	}

	._item_zocom_17 ._reward-pattern_zocom_54 .received-box .has-receive {
		display: block;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 1.1rem;
		height: .5rem;
		margin-top: .02rem;
		font-weight: 700;
		font-size: .22rem;
		line-height: .24rem;
		text-align: center;
		transform: scale(.7) rotate(-18deg)
	}

	._item_zocom_17 ._reward-pattern_zocom_54 .received-box .has-receive .text {
		position: relative;
		top: 0;
		display: grid;
		line-height: 0
	}

	._item_zocom_17 ._reward-pattern_zocom_54 .received-box .has-receive:lang(zh) {
		font-size: .32rem
	}

	._item_zocom_17 ._reward-pattern_zocom_54 .received-box .has-receive:lang(en) {
		font-size: .32rem
	}

	._item_zocom_17 ._reward-pattern_zocom_54 .received-box .has-receive:lang(pt) {
		font-size: .26rem
	}

	._item_zocom_17 ._reward-pattern_zocom_54 .picture {
		display: block;
		width: 100%;
		height: 100%
	}

	._item_zocom_17 ._reward-description_zocom_113 {
		margin-bottom: .01rem;
		padding: .01rem .1rem
	}

	._item_zocom_17 ._reward-description_zocom_113 .divider {
		border-top: 0.01rem solid var(--theme-text-color)
	}

	._item_zocom_17 ._reward-description_zocom_113 .text-wrap {
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		position: relative;
		width: 100%;
		height: .3rem;
		margin-bottom: .2rem;
		font-size: .22rem;
		line-height: .3rem;
		text-align: center
	}

	._item_zocom_17 ._reward-description_zocom_113 .yellow {
		color: var(--skin__accent_3)
	}

	._item_zocom_17 ._caption_zocom_135 {
		display: flex;
		align-items: center;
		justify-content: center;
		height: .4rem;
		padding-top: 0;
		color: var(--skin__neutral_2);
		font-size: .24rem;
		line-height: 1.29
	}

	._item_zocom_17 ._caption_zocom_135 ._sign-btn_zocom_145 {
		width: 1.2rem;
		height: .4rem;
		font-size: .18rem;
		border-radius: .1rem;
		padding: 0 .05rem
	}

	._item_zocom_17 ._caption_zocom_135 ._sign-btn_zocom_145 :not(:lang(zh)) .ui-button__text {
		word-break: break-word
	}

	.G9JHenpYWEhrwkyqb33R {
		-ms-flex-align: center;
		-ms-flex-pack: justify;
		align-items: center;
		display: flex;
		justify-content: space-between;
	}

	.xmHlf3AdKNfopQZxGTk7 {
		margin: .2rem;
		text-align: left;
		color: var(--theme-disabled-font-color);
		font-size: .24rem;
	}

	html .ant-btn.ant-btn-primary {
		width: 5rem;
		font-size: .24rem;
		background-color: var(--theme-primary-color);
		border-color: var(--theme-primary-color);
		margin-top: 0;
		display: flex;
		margin: 0 auto;
		text-align: center;
		align-items: center;
		justify-content: center;
	}

	html .ant-btn.ant-btn-primary {
		color: var(--theme-primary-font-color);
		text-shadow: none;
		height: .7rem;
		border-radius: .14rem;
	}

	.ZAJ3tO484KoZnr7Y6n_l {
		color: var(--theme-text-color-darken);
		font-size: .3rem;
		padding: .2rem .3rem;
		font-weight: 400
	}

	.RlMZ1IA0k4zaYVTGjIiN {
		color: var(--theme-text-color-darken);
		font-size: .22rem;
		margin-bottom: .4rem;
		margin-top: .3rem;
		min-height: .7rem
	}

	.advertisement_list {
		width: 7.1rem;
		box-sizing: border-box;
		text-align: center;
		background-color: var(--theme-main-bg-color);
		border-radius: .2rem;
	}

	.advertisement_list .title {
		/* color: var(--theme-label-secondary-color-finance); */
		text-align: center;
		line-height: 1rem;
		font-size: .4rem;
	}

	._common-tabs-content {
		max-height: 5.4rem;
		width: 100%;
	}

	.consliTst {
		display: flex;
		align-items: center;
		border-radius: .1rem;
		height: .8rem !important;
		background-color: rgba(var(--theme-primay-color-hex), .05);
		max-width: 2.05rem;
		padding: .15rem;
		text-align: revert !important;
	}

	.consliTst svg {
		width: .38rem;
		height: .38rem;
		color: var(--theme-primary-color);
		margin-right: .08rem;
	}

	.consliTst span {
		font-size: .22rem;
		display: inline-block;
		line-height: .28rem;
		flex: 1;
		color: var(--theme-primary-color);
		overflow: hidden;
		text-overflow: ellipsis;
		/* white-space: nowrap; */
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		display: -webkit-box;
		white-space: break-spaces !important;
	}
</style>